import { axios } from "configs/axios";

export type UpdatePasswordDTO = {
  token: string,
  newPassword: string,
}

export const updatePassword = (
  data: UpdatePasswordDTO
) => {
  return axios.post("/auth/updatepassword", data);
};